import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["kidsList", "adultsList", "toggle"]

    connect() {
        // default to kids unless a toggle is already selected
        const current = this.toggleTargets.find(t => t.checked)?.value || "kids"
        this.show(current)
    }

    switch(event) {
        this.show(event.currentTarget.value)
    }

    show(which) {
        const showKids = which === "kids"
        this.kidsListTarget.classList.toggle("d-none", !showKids)
        this.adultsListTarget.classList.toggle("d-none", showKids)
    }
}